import { Box } from "@mui/material";

interface RoundFlagProps {
  src?: string;
  alt: string;
  size?: number;
}

const RoundFlag = ({ src, alt, size = 22 }: RoundFlagProps) => {
  return (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: "50%",
        background: "linear-gradient(145deg, #ffffff, #f0f0f0)",
        border: "3px solid #fff", // thick white border
        boxShadow:
          "0 1px 2px rgba(0,0,0,0.25), inset 0 1px 1px rgba(255,255,255,0.9)",
        overflow: "hidden",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
      }}
    >
      {src && (
        <Box
          component="img"
          src={src}
          alt={alt}
          loading="lazy"
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
          onError={(e) => {
            (e.currentTarget as HTMLImageElement).style.display = "none";
          }}
        />
      )}
    </Box>
  );
};

export default RoundFlag;
